import React, { useContext } from "react";
import FacebookLogin from "react-facebook-login";
import Box from "@mui/material/Box";
import "../Styles/login.css";
import "../Styles/style.css";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import NextButton from "../Shared/NextButton";
import Divider from "@mui/material/Divider";
import Input from "../Shared/Input";
import consts from "../Utilities/appConsts.json";
import FacebookIcon from "@mui/icons-material/Facebook";
import { LanguageContext } from "../language/LanguageContext";
import useLoginPage from "../hook/useLoginPage"; // Import the custom hook
import ModalAlert from "../Shared/ModalAlert";
import { GoogleLogin } from "@react-oauth/google";

interface LoginProps {
  onForgetPasswordClick: () => void;
}

const Login: React.FC<LoginProps> = ({ onForgetPasswordClick }) => {
  const {
    mail,
    setMail,
    password,
    setPassword,
    setIsShowHelperTextEmail,
    setIsShowHelperTextPassword,
    isShowHelperTextEmail,
    isShowHelperTextPassword,
    handleResponse,
    handleFacebookResponse,
    handleGoogleResponse,
    isAddActiveModal,
    setIsAddActiveModal,
    titleModal,
    contentModal,
    textTrueModal,
    textFalseModal,
    setCheckRemember,
    checkRemember,
    loading,
    LoaderComponent,
  } = useLoginPage(); // Use the custom hook

  const { getTranslation } = useContext(LanguageContext);

  const isError = () => {};

  return (
    <>
      <div className="login-Typography">
        <h1 className="login-text">
          {getTranslation(consts.SIGN_IN_TO_LUPA)}
        </h1>
      </div>
      <LoaderComponent loading={loading}></LoaderComponent>
      <ModalAlert
        open={isAddActiveModal}
        onClose={(isApproved: boolean) => {
          setIsAddActiveModal(false);
        }}
        title={titleModal}
        content={contentModal}
        textTrue={textTrueModal}
        textFalse={textFalseModal}
      />
      <Box>
        <Input
          label={getTranslation(consts.EMAIL)}
          className="textField mb-input-login"
          characterLimit={49}
          name={"email"}
          isRequired={false}
          isComeFromLogin={true}
          variant="standard"
          testid="email-input-login"
          setIsError={isError}
          showHelperText={isShowHelperTextEmail ? true : false}
          setShowHelperText={setIsShowHelperTextEmail}
          helperText={isShowHelperTextEmail && "המייל או הסיסמה אינם תקינים"}
          endAdornment={false}
          value={mail ? mail : ""}
          setValue={(name: any, value: any, setShowHelperText: any) => {
            setMail(value);
            setShowHelperText && setIsShowHelperTextEmail(false);
          }}
        />
        <Input
          label={getTranslation(consts.PASSWORD)}
          className="textField mb-input-login"
          characterLimit={20}
          isRequired={false}
          isComeFromLogin={true}
          testid="pass-input-login"
          setShowHelperText={setIsShowHelperTextPassword}
          variant="standard"
          showHelperText={isShowHelperTextPassword ? true : false}
          helperText={isShowHelperTextPassword && "המייל או הסיסמה אינם תקינים"}
          type={consts.PASSWORD}
          setIsError={isError}
          endAdornment={true}
          value={password ? password : ""}
          setValue={(password: string) => setPassword(password)}
        />
      </Box>
      <div className="login-check-box">
        <div className="login-forget-password">
          <Typography component="div">
            <button
              type="button"
              onClick={onForgetPasswordClick}
              className="login-forget-password-text login-forget-password-button"
              aria-label={getTranslation(consts["FORGET_YOUR_PASSWORD?"])}
            >
              {getTranslation(consts["FORGET_YOUR_PASSWORD?"])}
            </button>
          </Typography>
        </div>
        <div style={{ marginLeft: "1rem" }}>
          <label className="login-remember-me">
            {getTranslation(consts.REMEMBER_ME)}
            <Checkbox
              checked={checkRemember}
              onClick={() => setCheckRemember(!checkRemember)}
              className="login-remember-me-check-box"
            />
          </label>
        </div>
      </div>

      <div className="login-btn">
        <NextButton
          handleOnClick={handleResponse}
          testid="btn-login"
          class="btn-fp-mail"
          text={getTranslation(consts.CONNECT_ME)}
        />
      </div>

      <Typography component="div" mb={"20px"}>
        <Divider className="login-divider">
          <span>{getTranslation(consts.IN_ADDITION)}</span>
        </Divider>
      </Typography>

      {/* Google and Facebook login buttons */}
      <GoogleLogin
        onSuccess={(response) => handleGoogleResponse(response)}
        onError={() => {
          console.log("Login Failed");
        }}
        text="signin_with"
        shape="circle"
        width={287}
      />
      {/* Facebook login button hidden */}
      {false && (
        <FacebookLogin
          appId={consts.FACEBOOK_APP_ID}
          fields="name,email,picture"
          callback={handleFacebookResponse}
          icon={<FacebookIcon />}
          textButton="Sign in with Facebook"
          cssClass="custom-facebook-button facebook-login"
        />
      )}
    </>
  );
};

export default Login;
